import React, { useState } from "react";
import {
  Typography,
  Stack,
  Box,
  IconButton
} from "@mui/material";
import { PhotoCameraIcon as PhotoCamera } from "../../icons";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../store/contexts";
import { AuthAvatar } from "../../common/components/AuthAvatar";
import { AvatarUploadDialog } from "../../common/components/AvatarUploadDialog";

export const ProfileSettingsPage = observer(() => {
  const rootStore = useRootStore();
  const { authStore, langStore } = rootStore;
  const [avatarDialogOpen, setAvatarDialogOpen] = useState(false);

  const handleAvatarSave = async (croppedImage: Blob) => {
    try {
      await authStore.updateAvatar(croppedImage);
    } catch (error) {
      console.error("Error updating avatar:", error);
    }
  };

  return (
    <Box>
      <Stack spacing={3}>
        <Box sx={{ position: 'relative', display: 'inline-block', width: 'fit-content' }}>
          <AuthAvatar
            avatarData={authStore.me?.avatar_data}
            name={authStore.me?.name || ''}
            userId={authStore.me?.id || ''}
            size={80}
            cacheVersion={authStore.avatarCacheVersion}
          />
          <IconButton
            sx={{
              position: 'absolute',
              bottom: -4,
              right: -4,
              bgcolor: 'primary.main',
              color: 'white',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
              width: 32,
              height: 32
            }}
            onClick={() => setAvatarDialogOpen(true)}
          >
            <PhotoCamera sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        <Box>
          <Typography variant="caption" color="text.secondary">
            {langStore.nameLabel}
          </Typography>
          <Typography variant="body1">
            {authStore.me?.name || '-'}
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" color="text.secondary">
            {langStore.emailLabel}
          </Typography>
          <Typography variant="body1">
            {authStore.me?.email || '-'}
          </Typography>
        </Box>
      </Stack>

      <AvatarUploadDialog
        open={avatarDialogOpen}
        onClose={() => setAvatarDialogOpen(false)}
        onSave={handleAvatarSave}
      />
    </Box>
  );
});
